import { useConfig } from 'domains/config/hooks'
import { useEffect, useRef } from 'preact/hooks'
import { useSeamlyOptions } from 'ui/hooks/seamly-hooks'

const SeamlyInitializer = () => {
  const { initUserSelectedOptions } = useSeamlyOptions()
  const seamlyInitialized = useRef(false)
  const config = useConfig()

  useEffect(() => {
    if (config.api && !seamlyInitialized.current) {
      seamlyInitialized.current = true
      initUserSelectedOptions()
    }
  }, [initUserSelectedOptions, config])

  return null
}

export default SeamlyInitializer
